






















import { Component, Vue } from 'vue-property-decorator';
import {
  DxDataGrid,
  DxEditing,
  DxStateStoring,
} from 'devextreme-vue/data-grid';
import {
  SuppliersClient,
  ContactBasicsDto,
  RawMaterialsClient,
} from '@/data/web-api-client';
import notificationService from '@/services/notificationService';
import ImportRawMaterialsFileDialog from '@/modules/rawMaterials/Components/ImportRawMaterialsFileDialog.vue';

@Component({
  components: {
    DxDataGrid,
    DxEditing,
    DxStateStoring,
    ImportRawMaterialsFileDialog,
  },
})
export default class SuppliersTable extends Vue {
  private loading: boolean = true;
  private exporting: boolean = false;
  private items: ContactBasicsDto[] = [];
  private client: SuppliersClient = new SuppliersClient(undefined, this.$axios);
  private selectedWholesale: any = {};
  private showUploadPopup: boolean = false;
  // private accessToken: string = '';

  private startUpload(e: any) {
    // this.selectedWholesale = e.row.data;
    // this.showUploadPopup = true;

    (this.$refs.ImportRawMaterialsFileDialog as ImportRawMaterialsFileDialog).open(e.row.data);
  }

  private async exportData(e: any) {
    try {
      this.exporting = true;
      const supplier = e ? e.row.data as ContactBasicsDto : undefined;
      const client = new RawMaterialsClient(undefined, this.$axios);
      const file = await client.exportData( supplier ? supplier.id : '');
      const blobURL = window.URL.createObjectURL(file.data);
      const tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', supplier ? `export-${supplier.displayName}.csv` : 'export.csv');
      // Safari thinks _blank anchor are pop ups. We only want to set _blank
      // target if the browser does not support the HTML5 download attribute.
      // This allows you to download files in desktop safari if pop up blocking
      // is enabled.
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
      }
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(blobURL);
      }, 500);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.exporting = false;
    }
  }

  private async created() {
    // this.accessToken = await this.$auth.getAccessToken() as string;
    try {
      this.loading = true;
      this.items = await this.client.getAll();
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  get columns() {
    return [
      {
        dataField: 'displayName',
        caption: 'Naam',
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'Download',
            icon: 'fas fa-file-download',
            // visible: this.isCloneIconVisible,
            onClick: this.exportData,
          },
          {
            hint: 'Upload',
            icon: 'fas fa-file-upload',
            // visible: this.isCloneIconVisible,
            onClick: this.startUpload,
          },
        ],
      },
    ];
  }
}
